import { IReport } from "../../types";

export interface IBuildingCompare extends IReport {
}

export const schema  = "AutomationApps.ReportsAndStatistics.Portfolio.BuildingsCompare";
export const schemaOld  = "AutomationApps.Energy.BuildingsCompare";